<template>
  <div class="col-12">

    
    <div class="row mt-3">
      
      <div class="col-12" v-if="measurementsShaping && yLabelsShaping">
  
        <line-shaping-chart class="row mt-2" v-bind:datasets="fetchDatasetForShapingChart(measurementsShaping)"
                            key="shapingChart"
                            :stageId="stage.id"
                            v-bind:y-labels="yLabelsShaping"
                            :list-chart-date="xLabelsShaping"
                            v-bind:vertical-line-point="changes"
                            v-bind:show-legend="false"
                            v-bind:y-axes-begin-at-zero="true"
                            v-on:popup-show="popupShow"
                            :height="680"
                            :width=null
                            :aspect-ratio=false
        />
        <h4 class="chart__title mb-3">{{'protocol.shaping_chart' | trans}} "{{stage.description}}"</h4>
        
      </div>

      
    </div>
  
    <div v-if="isShapingModalVisible">
    
    
      <chart-popup :visible="isShapingModalVisible"
                   v-on:close="onClose"
                   :stage-id="stage.id"
                   :protocolId="protocolId"
                   :dataPoint="dataPoint">
      </chart-popup>
  
    </div>
   

  </div>


</template>

<script>

  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import TableView from '../../../common/table/components/TableView';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import {LineChartDataset, LineShapingChart} from '../../../common/chart';
  import split from 'lodash/split';
  import Loader from '../../loader/components/Loader';
  import ChartPopup from './ChartPopupShaping';
  
  export default {
    props: ['stage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'isApplyFilter'],
    components: {
      TableView, LineShapingChart, LineChartDataset, Loader, ChartPopup
    },

    data() {
      return {
        isChange: false,
        list: [],
        persentMax: true,
        apiUrl: '/protocols/assigned/',
        measurementsShaping: null,
        changesLine: [],
        withoutData: false,
        loaded: true,
        isShapingModalVisible: false,
        dataPoint: null,
        selectedStageId: null,
        yLabelsShaping: null,
        xLabelsShaping: null,
        changes: null
      };
    },

    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),
      
    },

    async created() {
      this.chartShow();
    },

    methods: {

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      startedAt(h, row) {
        return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
      },

      masteredAt(h, row) {
        return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
      },

      async requestFunction (data) {
        this.isChange = false;
        return this.onSendRequest(this.options.perPage, data.page);
      },

      popupShow(data,stageId){
          this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
          this.selectedStageId = stageId;
          this.isShapingModalVisible = true;

      },

      onClose() {
        this.isShapingModalVisible = false;
      },

      fetchDatasetForShapingChart(data){
        let dataChart = [];

        forEach(data, chart => {
          dataChart.push(new LineChartDataset({
            data: chart,
            pointBorderWidth: 2
          }));

          let value = split(chart[0].y, '_');

          dataChart.push(new LineChartDataset({
            data: [
              {
                x: chart[0].x,
                y: value[0] + '_0',
              },
              {
                x: chart[chart.length - 1].x,
                y: value[0] + '_0',
              },
            ],
            pointRadius: 0,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            borderWidth: 2,
            borderDash: [12,10]
          }));

        });

        return dataChart;

      },
      
      async chartShow(){
        this.loaded = false;
        this.changesLine = [];
        let dataForChart = [];
        

        let url = this.apiUrl + 'shaping/' + this.protocolId + '/mensuration/' + this.stage.id;
        let response = await axios.get(url, {
          params: {
            startDate: this.rangeDateStartTimestamp,
            endDate: this.rangeDateEndTimestamp
          }
        });
        this.measurementsShaping = response.data.data.data;
        this.yLabelsShaping = response.data.data.yLabels;
        this.xLabelsShaping = response.data.data.xLabels;
        if(this.xLabelsShaping){
          this.xLabelsShaping.push("  ")
        }
        this.changes = response.data.data.changes;
      
        this.loaded = true;
      },

      onSendRequest: async function (perPage, page) {
        this.list = [];

        let url = this.apiUrl + 'chain/' + this.protocolId + '/stimuli-introduced-mastered-history/';

        let params = {
          perPage: perPage,
          page: page,
          stageId: this.stage.id,
        };
        let response = await axios.get(url, {params: params});
        this.list = response.data.data.items;
        return response;
      },

      
    },
    watch:{
      isApplyFilter(){
        this.chartShow();
      }
    }

  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentStageShaping.vue